module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answer",
    class: _vm.startNode ? 'start-node' : ''
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "answerTitle",
    on: {
      "dblclick": function($event) {
        return _vm.openAnswerOptionEditor()
      }
    }
  }, [_vm._v(_vm._s(_vm.tmp.title))]), _vm._v(" "), (_vm.tmp.isSilence) ? _c('div', {
    staticClass: "silence_or_illegibly silence",
    on: {
      "dblclick": function($event) {
        return _vm.openAnswerOptionEditor()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-comment-slash"
  })]) : _vm._e(), _vm._v(" "), (_vm.tmp.isIllegibly) ? _c('div', {
    staticClass: "silence_or_illegibly illegibly",
    on: {
      "dblclick": function($event) {
        return _vm.openAnswerOptionEditor()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-comment-dots"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.tags && _vm.tmp.tags.length > 0),
      expression: "tmp.tags && tmp.tags.length > 0"
    }],
    staticClass: "answerWords",
    on: {
      "dblclick": function($event) {
        return _vm.openAnswerOptionEditor()
      }
    }
  }, [_c('span', {
    staticClass: "bkt"
  }, [_vm._v("(")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.wordsStrFormat()))]), _c('span', {
    staticClass: "bkt"
  }, [_vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "answerOptionEdit hidden_for_client_automation",
    on: {
      "click": function($event) {
        return _vm.openAnswerOptionEditor()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "windowButtons"
  }, [_c('button', {
    staticClass: "window-small window-change-type",
    attrs: {
      "aria-label": _vm.$t('scenarios.konstruktor.canvas.answer.windowSizes.smallSize')
    },
    on: {
      "click": function($event) {
        return _vm.setWindowSmall(true)
      }
    }
  }, [_c('i', {
    staticClass: "far fa-window-minimize"
  })]), _vm._v(" "), _c('button', {
    staticClass: "window-medium window-change-type",
    attrs: {
      "aria-label": _vm.$t('scenarios.konstruktor.canvas.answer.windowSizes.mediumSize')
    },
    on: {
      "click": function($event) {
        return _vm.setWindowMedium(true)
      }
    }
  }, [_c('i', {
    staticClass: "far fa-window-restore"
  })]), _vm._v(" "), _c('button', {
    staticClass: "window-big window-change-type",
    attrs: {
      "aria-label": _vm.$t('scenarios.konstruktor.canvas.answer.windowSizes.maxSize')
    },
    on: {
      "click": function($event) {
        return _vm.setWindowBig(true)
      }
    }
  }, [_c('i', {
    staticClass: "far fa-window-maximize"
  })]), _vm._v(" "), _c('button', {
    staticClass: "delete hidden_for_client_automation",
    attrs: {
      "aria-label": "delete"
    },
    on: {
      "click": function($event) {
        return _vm.remove()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.editOption),
      expression: "!!editOption"
    }],
    staticClass: "wordsEditor"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('div', {
    staticClass: "modal-card-title"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.title),
      expression: "tmp.title"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "title"
    },
    domProps: {
      "value": (_vm.tmp.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeAnswerOptionEditor()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "nonStartNode"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox isSilence"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.isSilence),
      expression: "tmp.isSilence"
    }],
    staticClass: "isSilence checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tmp.isSilence) ? _vm._i(_vm.tmp.isSilence, null) > -1 : (_vm.tmp.isSilence)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tmp.isSilence,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tmp, "isSilence", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tmp, "isSilence", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tmp, "isSilence", $$c)
        }
      }
    }
  }), _vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.silence')))]), _vm._v(" "), _c('label', {
    staticClass: "checkbox isIllegibly"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.isIllegibly),
      expression: "tmp.isIllegibly"
    }],
    staticClass: "isIllegibly checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tmp.isIllegibly) ? _vm._i(_vm.tmp.isIllegibly, null) > -1 : (_vm.tmp.isIllegibly)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tmp.isIllegibly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tmp, "isIllegibly", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tmp, "isIllegibly", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tmp, "isIllegibly", $$c)
        }
      }
    }
  }), _vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.illegibly')))])]), _vm._v(" "), _c('div', {
    staticClass: "is-block value"
  }, [_c('label', {
    staticClass: "is-block"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.foStatusValueUse')) + ": ")]), _vm._v(" "), _c('div', {
    staticClass: "is-block"
  }, [_c('vb-switch-with-two-labels', {
    attrs: {
      "model": _vm.tmp.useSetValue,
      "label-left": _vm.$t('scenarios.konstruktor.canvas.answer.transcription'),
      "label-right": _vm.$t('scenarios.konstruktor.canvas.answer.indicate')
    },
    on: {
      "update:model": function($event) {
        return _vm.$set(_vm.tmp, "useSetValue", $event)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.stateValue),
      expression: "tmp.stateValue"
    }],
    staticClass: "input stateValue",
    attrs: {
      "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.stateValue')
    },
    domProps: {
      "value": (_vm.tmp.stateValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "stateValue", $event.target.value)
      }
    }
  })], 1)]), _vm._v(" "), _c('vue-tags', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var tag = ref.tag;
        var removeTag = ref.removeTag;
        var inputEventHandlers = ref.inputEventHandlers;
        var inputBindings = ref.inputBindings;

        return _c('div', {
          staticClass: "tags-input tags are-large"
        }, [_c('button', {
          staticClass: "button addForAll",
          attrs: {
            "type": "button",
            "title": _vm.$t('scenarios.konstruktor.canvas.answer.synonyms.addForAllWithSameTitle')
          },
          on: {
            "click": function($event) {
              return _vm.addWordsForAllByTitle(_vm.tmp)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-copy"
        })]), _vm._v(" "), _vm._l((_vm.tmp.tags), function(tag) {
          return _c('span', {
            staticClass: "tags-input-tag tag is-large"
          }, [_vm._v("\n                    " + _vm._s(tag) + "\n                    "), _c('button', {
            staticClass: "tags-input-remove delete",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return removeTag(tag)
              }
            }
          })])
        }), _vm._v(" "), _c('div', {
          staticClass: "control"
        }, [_c('input', _vm._g(_vm._b({
          staticClass: "tags-input-text input",
          attrs: {
            "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.synonyms.addWord') + '...'
          }
        }, 'input', inputBindings, false), inputEventHandlers))])], 2)
      }
    }]),
    model: {
      value: (_vm.tmp.tags),
      callback: function($$v) {
        _vm.$set(_vm.tmp, "tags", $$v)
      },
      expression: "tmp.tags"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.stateQuestion),
      expression: "tmp.stateQuestion"
    }],
    staticClass: "input stateQuestion",
    attrs: {
      "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.stateQuestion')
    },
    domProps: {
      "value": (_vm.tmp.stateQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "stateQuestion", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tabs is-boxed"
  }, [_c('ul', [_c('li', {
    staticClass: "tab generateFromText",
    class: _vm.answerGenerationType === 'generateFromText' || !_vm.answerGenerationType ? 'is-active' : '',
    attrs: {
      "data-type": "generateFromText"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.activateTab('generateFromText')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.fromText')))])])]), _vm._v(" "), _c('li', {
    staticClass: "tab inputUrls",
    class: _vm.answerGenerationType === 'inputUrls' ? 'is-active' : '',
    attrs: {
      "data-type": "inputUrls"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.activateTab('inputUrls')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toPutUrl')))])])]), _vm._v(" "), _c('li', {
    staticClass: "tab uploadFile",
    class: _vm.answerGenerationType === 'uploadFile' ? 'is-active' : '',
    attrs: {
      "data-type": "uploadFile"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.activateTab('uploadFile')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toUploadFromFile')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "tab-content generateFromText main",
    class: _vm.answerGenerationType === 'generateFromText' || !_vm.answerGenerationType ? 'is-active' : ''
  }, [_c('input', {
    staticClass: "generationType",
    attrs: {
      "type": "hidden",
      "value": "generateFromText"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.text),
      expression: "tmp.text"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.currentVendor.toLowerCase() !== 'google' || _vm.tmp.googleSsmlType !== 'ssml'),
      expression: "tmp.currentVendor.toLowerCase()!=='google' || tmp.googleSsmlType !== 'ssml'"
    }],
    staticClass: "textarea text",
    domProps: {
      "value": (_vm.tmp.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('codemirror', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.currentVendor.toLowerCase() === 'google' && _vm.tmp.googleSsmlType === 'ssml'),
      expression: "tmp.currentVendor.toLowerCase()==='google' && tmp.googleSsmlType === 'ssml'"
    }],
    staticClass: "text",
    attrs: {
      "options": {
        mode: 'text/html',
        lineWrapping: true,
        showCursorWhenSelecting: true
      }
    },
    model: {
      value: (_vm.tmp.text),
      callback: function($$v) {
        _vm.$set(_vm.tmp, "text", $$v)
      },
      expression: "tmp.text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped generate_audio_controls"
  }, [_c('button', {
    staticClass: "button add_parameter generate_audio_control generate_audio_control_first",
    attrs: {
      "title": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toAddParameter')
    },
    on: {
      "click": function($event) {
        return _vm.addParameter()
      }
    }
  }, [_c('span', [_vm._v("{ + }")])]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary vendorControl generate_audio_control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentVendor),
      expression: "tmp.currentVendor"
    }],
    staticClass: "form-control vendor",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentVendor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onVendorChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "yandex"
    }
  }, [_vm._v("Yandex")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "google"
    }
  }, [_vm._v("Google")])])]), _vm._v(" "), _c('div', {
    staticClass: "is-primary speaker generate_audio_control"
  }, [(_vm.tmp.currentVendor.toLowerCase() === 'yandex') ? _c('div', {
    staticClass: "select yandex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeaker),
      expression: "tmp.currentSpeaker"
    }],
    staticClass: "form-control voice",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.yandexSpeakerList), function(speaker) {
    return _c('option', {
      class: speaker.premium ? 'premium' : '',
      domProps: {
        "value": speaker.value
      }
    }, [_vm._v("\n                    " + _vm._s(speaker.label + (speaker.premium ? (" " + " " + " " + " " + " " + " " + " " + "👑") : "")) + "\n                  ")])
  }), 0)]) : _c('div', {
    staticClass: "google"
  }, [(_vm.googleLanguages) ? _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentLang),
      expression: "tmp.currentLang"
    }],
    staticClass: "form-control lang",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentLang", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onGoogleLanguageChange]
    }
  }, _vm._l((_vm.googleLanguages), function(language) {
    return _c('option', {
      domProps: {
        "value": language.value
      }
    }, [_vm._v("\n                      " + _vm._s(language.label) + "\n                    ")])
  }), 0)]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentLang),
      expression: "tmp.currentLang"
    }],
    staticClass: "input form-control lang",
    attrs: {
      "type": "text",
      "placeholder": "lang"
    },
    domProps: {
      "value": (_vm.tmp.currentLang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "currentLang", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.googleVoicesMapList && _vm.googleVoicesMapList[_vm.tmp.currentLang]) ? _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeaker),
      expression: "tmp.currentSpeaker"
    }],
    staticClass: "form-control voice",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.googleVoicesMapList[_vm.tmp.currentLang]), function(speaker) {
    return _c('option', {
      domProps: {
        "value": speaker.value
      }
    }, [_vm._v("\n                      " + _vm._s(speaker.label) + "\n                    ")])
  }), 0)]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeaker),
      expression: "tmp.currentSpeaker"
    }],
    staticClass: "input form-control voice",
    attrs: {
      "type": "text",
      "placeholder": "voiceName"
    },
    domProps: {
      "value": (_vm.tmp.currentSpeaker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "currentSpeaker", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.googleSsmlType),
      expression: "tmp.googleSsmlType"
    }],
    staticClass: "form-control ssmlType",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "googleSsmlType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "text"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.text')) + "\n                    ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ssml"
    }
  }, [_vm._v("\n                      SSML\n                    ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.currentVendor.toLowerCase() === 'yandex'),
      expression: "tmp.currentVendor.toLowerCase()==='yandex'"
    }],
    staticClass: "select is-primary generate_audio_control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotion),
      expression: "tmp.currentEmotion"
    }],
    staticClass: "form-control emotion",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', {
      domProps: {
        "value": emotion.value
      }
    }, [_vm._v("\n                  " + _vm._s(emotion.label) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "speed generate_audio_control"
  }, [_c('slider', {
    attrs: {
      "size": "small",
      "value": parseFloat(_vm.tmp.currentSpeed),
      "min": 0.5,
      "step": 0.1,
      "max": 2
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeed = $event
      }
    }
  }), _vm._v("\n              " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.speed')) + ": " + _vm._s(_vm.tmp.currentSpeed) + "\n            ")], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-primary generate_button generate_audio_control generate_audio_control_last",
    attrs: {
      "disabled": !_vm.tmp.text
    },
    on: {
      "click": function($event) {
        return _vm.genMainAudio()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.generateAudio')) + "\n            ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content inputUrls",
    class: _vm.answerGenerationType === 'inputUrls' ? 'is-active' : ''
  }, [_c('input', {
    staticClass: "generationType",
    attrs: {
      "type": "hidden",
      "value": "inputUrls"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "control urls",
    class: _vm.tmp.audio.length === 1 ? 'singleItem' : (_vm.tmp.audio.length > 3 ? 'more3_items' : '')
  }, [_vm._l((_vm.tmp.audio), function(audio) {
    return _c('div', {
      staticClass: "urlForAudio"
    }, [(audio.type === 'url') ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.url),
        expression: "audio.url"
      }],
      staticClass: "input url",
      attrs: {
        "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.putUrl')
      },
      domProps: {
        "value": (audio.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fas fa-minus-square fa-3x remove_audio_item",
      attrs: {
        "title": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toRemoveUrl')
      },
      on: {
        "click": function($event) {
          return _vm.removeAudioItem(audio)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (audio.type === 'param') ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.paramName),
        expression: "audio.paramName"
      }],
      staticClass: "input param",
      attrs: {
        "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.putParameterName')
      },
      domProps: {
        "value": (audio.paramName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "paramName", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fas fa-minus-square fa-3x remove_audio_item",
      attrs: {
        "title": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toRemoveParameter')
      },
      on: {
        "click": function($event) {
          return _vm.removeAudioItem(audio)
        }
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "add_url",
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "title": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toAddUrl')
    },
    on: {
      "click": function($event) {
        return _vm.addAudioItem('url')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link fa-2x add_audio_item"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-square fa-3 add_audio_item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "add_param",
    staticStyle: {
      "display": "inline",
      "margin-left": "20px"
    },
    attrs: {
      "title": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toAddParameter')
    },
    on: {
      "click": function($event) {
        return _vm.addAudioItem('param')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-audio-description fa-2x add_audio_item"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-square fa-3 add_audio_item"
  })])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content uploadFile",
    class: _vm.answerGenerationType === 'uploadFile' ? 'is-active' : ''
  }, [_c('input', {
    staticClass: "generationType",
    attrs: {
      "type": "hidden",
      "value": "uploadFile"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "control uploadFromFileDiv"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toUploadFromFile')
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "loadFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getValidAudioUrlsCount() > 0),
      expression: "getValidAudioUrlsCount()>0"
    }],
    staticClass: "button is-delete",
    attrs: {
      "type": "button",
      "value": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toRemoveAll')
    },
    on: {
      "click": function($event) {
        return _vm.removeAudioItems()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "mainAudioList",
    class: _vm.getAudioSizeClass()
  }, [_c('div', {
    staticClass: "audio_list"
  }, _vm._l((_vm.tmp.audio), function(audio) {
    return _c('div', {
      staticClass: "audio audio_item",
      class: _vm.getAudioClass(audio)
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.id),
        expression: "audio.id"
      }],
      staticClass: "id",
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (audio.id)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "id", $event.target.value)
        }
      }
    }), _vm._v(" "), (audio.url || audio.paramName) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.number),
        expression: "audio.number"
      }],
      staticClass: "number",
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (audio.number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "number", $event.target.value)
        }
      }
    }), _vm._v(" "), (audio.type === 'url') ? _c('audio', {
      ref: 'onPlayer',
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": audio.url
      }
    }), _vm._v("\n                " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')) + "\n              ")]) : _vm._e(), _vm._v(" "), (audio.type === 'url') ? _c('audio-player', {
      attrs: {
        "file": audio.url,
        "onLoad": function(data) {
          audio.duration = data.duration
        }
      }
    }) : _vm._e(), _vm._v(" "), (audio.type === 'param') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.paramName),
        expression: "audio.paramName"
      }],
      staticClass: "audioParam",
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (audio.paramName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "paramName", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (audio.type === 'url') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.duration),
        expression: "audio.duration"
      }],
      staticClass: "audioDuration",
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (audio.duration)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "duration", $event.target.value)
        }
      }
    }) : _vm._e()], 1) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.getAudioSizeClass()
  }, [_c('button', {
    staticClass: "audioConfig hidden_for_client_automation",
    attrs: {
      "aria-label": _vm.$t('scenarios.konstruktor.canvas.answer.audioConfig')
    },
    on: {
      "click": function($event) {
        _vm.showPlaySourceConfig = !_vm.showPlaySourceConfig
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-cog"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.showPlaySourceConfig),
      expression: "!!showPlaySourceConfig"
    }],
    staticClass: "playSourceConfig"
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('div', {
    staticClass: "modal-card-title"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.settings')) + " SpeechCollect")])])]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close",
      "title": _vm.$t('common.actions.close')
    },
    on: {
      "click": function($event) {
        _vm.showPlaySourceConfig = false
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.key')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))])])]), _vm._v(" "), _c('tbody', [_c('tr', {}, [_c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.recognition.recognitionDriver')))])]), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.recognitionDriver),
      expression: "tmp.recognitionDriver"
    }],
    staticClass: "form-control recognitionDriver",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "recognitionDriver", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.default')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "google"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yandex"
    }
  }, [_vm._v("Yandex")])])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "searchStrategyTr"
  }, [_vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.searchStrategy),
      expression: "tmp.searchStrategy"
    }],
    staticClass: "searchStrategy",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "searchStrategy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "CONTAINS"
    }
  }, [_vm._v("contains")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CONTAINS_FULL_SPEECH"
    }
  }, [_vm._v("contains full speech")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EQUALS"
    }
  }, [_vm._v("equals")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EQUALS_FULL_SPEECH"
    }
  }, [_vm._v("equals full speech")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CONTAINS_AND_EQUALS_FULL_SPEECH"
    }
  }, [_vm._v("contains and equals full speech")])])])])])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.timeout),
      expression: "tmp.timeout"
    }],
    staticClass: "input timeout",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.timeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "timeout", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.startCollectBeforePlayEnd),
      expression: "tmp.startCollectBeforePlayEnd"
    }],
    staticClass: "input startCollectBeforePlayEnd",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.startCollectBeforePlayEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "startCollectBeforePlayEnd", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.waitingInputTimeout),
      expression: "tmp.waitingInputTimeout"
    }],
    staticClass: "input waitingInputTimeout",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.waitingInputTimeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "waitingInputTimeout", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.silenceAfterSpeechTimeout),
      expression: "tmp.silenceAfterSpeechTimeout"
    }],
    staticClass: "input silenceAfterSpeechTimeout",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.silenceAfterSpeechTimeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "silenceAfterSpeechTimeout", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.delayBeforeCollect),
      expression: "tmp.delayBeforeCollect"
    }],
    staticClass: "input delayBeforeCollect",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.delayBeforeCollect)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "delayBeforeCollect", $event.target.value)
      }
    }
  })])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Search Strategy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Timeout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Start Collect Before PlayEnd")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Waiting Input Timeout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Silence After Speech Timeout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Delay Before Collect")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-879764ec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/UniversalAnswer.vue
// module id = 463
// module chunks = 42